import type { GridPinnedColumns } from '@mui/x-data-grid-pro'

import { ListColumnSetting, Pinned } from './use-list-service/types'

export function mapListSettingsToPinnedColumns(columns: ListColumnSetting[]): GridPinnedColumns {
  const result: Required<GridPinnedColumns> = {
    left: [],
    right: []
  }

  return columns.reduce((result, column) => {
    if (column.Pinned === Pinned.LEFT) result.left.push(column.Name)
    if (column.Pinned === Pinned.RIGHT) result.right.push(column.Name)
    return result
  }, result)
}
